import React from "react";
import nodeinstance from "../../../../nodeInstance";
import { useEffect } from "react";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { setAppError, setBreadCrumb } from "../../../../store/userSlice";
import { useLocation, useNavigate } from "react-router-dom";

export default function GenereteInvoice({
  selectedCandidates,
  client,
  setSelectedCandidates,
}) {
  const row = [
    {
      id: 1,
      name: "YTC",
    },
  ];

  const rowsData = [
    {
      id: 1,
      name: "YTC",
    },
  ];
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const calculateTotalAmount = (employeeData) => {
    // Initialize total amount
    let total = 0;
    console.log("dgyggyugygfugggfugfu", employeeData);
    // Iterate through each fee and add its cost to the total
    employeeData?.fees?.forEach((fee) => {
      total += parseFloat(fee.cost);
    });

    // Return the total amount with 2 decimal places
    return total.toFixed(2);
  };

  const createDefaultRow = (index) => {
    return {
      id: index + 1,
      actual_professionId: "",
      visa_professionId: "",
      profession_level: "",
      gender: "",
      nationality: "",
      quantity: "",
      basic: "",
      food: "",
      fixed_ot: "",
      hra: "",
      travel_allowance: "",
      mobile_allowance: "",
      additional_ot: "",
      other_allowance: "",
    };
  };
  const [rowData, setRowsData] = useState(() => {
    const initialRows = [];
    for (let i = 0; i < 1; i++) {
      initialRows.push({ id: i + 1, ...createDefaultRow() });
    }
    return initialRows;
  });

  const tableHeading = [
    {
      rate_category_id: 1,
      title: "EMPLOYEE SALARY PACKAGE",
      bgPrimary: "bg-gray",
      bgSecondary: "bg-gray",
    },
  ];

  const totalTableHeading = [
    {
      title: "EMPLOYEE SALARY PACKAGE",
      bgPrimary: "bg-white", // Change background color to white
      bgSecondary: "bg-white", // Change background color to white
    },
  ];

  const tableProperties = {
    colWidth: "w-56",
    colHeight: "h-[2rem]",
    itemHeight: "h-[3rem]",
  };
  const tableProperties2 = {
    colWidth: "w-28",
    colHeight: "h-[2rem]",
    itemHeight: "h-[3rem]",
  };
  const dropDownData = [90, 180, 270, 360];
  const token = localStorage.getItem("nodeToken");
  //   const [employeeData, setEmployeeData] = useState([]);
  const [employeeData, setEmployeeData] = useState({ emp: [], fees: [] });

  const response = async () => {
    const reqObj = {
      candidate_id: selectedCandidates,
    };
    try {
      const data = await nodeinstance.post(
        "/dashboard/invoiceCostPlus/getEmpDetails",
        reqObj,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      if (data.status === 200) {
        setEmployeeData(data?.data);
        setSelectedCandidates([]);
      }
    } catch (error) {
      console.log("error to be seen here..", error);
    }
  };
  useEffect(() => {
    response();
  }, []);

  const [combinedData, setCombinedData] = useState([]);
  useEffect(() => {
    const newCombinedData = [];
    let total = 0; // Initialize total outside the loop
    let totalInvoiceAmount = 0;

    // Iterate through each fee and add its cost to the total
    employeeData?.fees.forEach((fee) => {
      total += parseFloat(fee.cost);
    });

    employeeData?.emp.forEach((empArr) => {
      empArr.forEach((empObj) => {
        const combinedObj = {
          ...empObj,
          tenure: "",
          fees: employeeData?.fees,
          totalFees: total.toFixed(2),
          InvoiceAmount: (totalInvoiceAmount += parseFloat(
            empObj.totalFees
          ).toFixed(2)),
          client_id: client,
        };
        newCombinedData.push(combinedObj);
      });
    });
    console.log("newCombinedData.....newCombinedData", newCombinedData);
    setCombinedData(newCombinedData);
  }, [employeeData]);

  console.log("employeeData.....to be seen....", combinedData);

  const handleQuantityChange = (mainIndex, feeIndex, value) => {
    setCombinedData((prevData) => {
      const updatedData = [...prevData];
      const updatedFees = [...updatedData[mainIndex].fees];

      updatedFees[feeIndex] = { ...updatedFees[feeIndex], cost: value };

      updatedData[mainIndex] = { ...updatedData[mainIndex], fees: updatedFees };

      return updatedData;
    });
  };
  const [globalTenure, setGlobalTenure] = useState();
  const handleGlobalTenurechange = (e) => {
    setGlobalTenure(e.target.value);
  };

  useEffect(() => {
    // Update fees based on globalTenure
    const updatedFees = employeeData.fees.map((fee) => {
      const totalCost = parseFloat(fee.cost);
      const perDayCost = totalCost / 360;
      const updatedCost = perDayCost * globalTenure;
      return {
        ...fee,
        cost: updatedCost.toFixed(2),
      };
    });
    console.log("updatedFesssssssss....s.s..s.s..s.s.s", updatedFees);
    // Calculate total fees based on the updated cost of each fee
    let total = 0;
    updatedFees?.forEach((fee) => {
      total += parseFloat(fee.cost);
    });

    // Update totalFees in combinedData based on the updated fees
    setCombinedData((prevData) => {
      return prevData.map((data) => ({
        ...data,
        fees: updatedFees,
        // totalFees: total.toFixed(2),
        tenure: globalTenure,
        // totalFees: (total * (globalTenure / 365)).toFixed(2),
        totalFees: total.toFixed(2),
      }));
    });
  }, [globalTenure]);

  console.log("global.....value....", combinedData);
  const [localTenure, setLocalTenure] = useState();

  const handleLocalTenure = (e, mainIndex) => {
    setLocalTenure(e.target.value);
    setCombinedData((prevData) => {
      return prevData.map((data, index) => {
        if (index === mainIndex) {
          // Update fees for the object at mainIndex using employeeData
          const updatedFees = employeeData.fees.map((fee) => {
            const totalCost = parseFloat(fee.cost);
            const perDayCost = totalCost / 360;
            const updatedCost = perDayCost * e.target.value;
            return {
              ...fee,
              cost: updatedCost.toFixed(2),
            };
          });
          // Return updated object with updated fees
          let total = 0;
          updatedFees?.forEach((fee) => {
            total += parseFloat(fee.cost);
          });
          console.log("updatedFees...345678....", total);
          return {
            ...data,
            fees: updatedFees,
            tenure: e.target.value,
            totalFees: total.toFixed(2),
          };
        } else {
          // Return unchanged object for other indices
          return data;
        }
      });
    });
    console.log(
      "data map to be displayed here.....",
      e.target.value,
      mainIndex
    );
  };

  console.log("combinedData......combine....", combinedData);
  console.log("combinedData......combine....", employeeData);

  // useEffect(() => {
  //   let total = 0; // Initialize total outside the loop

  //   // Iterate through each fee and add its cost to the total
  //   setTimeout(() => {
  //     combinedData?.fees?.forEach((fee) => {
  //       total += parseFloat(fee.cost);
  //     });

  //     setCombinedData((prevData) => {
  //       return prevData.map((data) => ({
  //         ...data,
  //         totalFees: (total * (globalTenure / 365)).toFixed(2),
  //         tenure: globalTenure, // Update totalFees based on globalTenure
  //       }));
  //     });
  //   }, 5000);
  // }, [globalTenure]);

  const GenerateInvoice = async () => {
    let InvoiceAmount = 0;
    // combinedData?.forEach((fee) => {
    //   InvoiceAmount += parseInt(fee.totalFees);
    // });
    combinedData.map((data, i) => {
      InvoiceAmount += parseFloat(data.totalFees);
    });
    console.log("dtytdftfdtcftdftftfd", InvoiceAmount);
    const updatedData = combinedData.map((data, index) => {
      // Increment sequence if it exists, otherwise start with 1
      const updatedSequence =
        data?.sequence == null ? 1 : parseInt(data.sequence, 10) + 1;
      return {
        ...data,
        sequence: updatedSequence,
      };
    });
    const reqObject = {
      updatedData,
      InvoiceAmount: InvoiceAmount,
    };

    console.log("reqObject.....reqObject", reqObject);
    try {
      const response = await nodeinstance.post(
        `/dashboard/invoiceCostPlus/addPerforma`,
        reqObject,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      if (response.status === 200) {
        setSelectedCandidates([]);
        dispatch(
          setAppError({
            msg: "Invoice generated successfully...",
            color: "success",
          })
        );
        navigate("/dashboard/invoice-cost-plus");
      }
    } catch (error) {
      dispatch(
        setAppError({
          msg: error.message,
          color: "success",
        })
      );
    }
  };

  useEffect(() => {
    dispatch(
      setBreadCrumb([
        {
          label: "INVOICE COST-PLUS",
          link: "/dashboard/invoice-cost-plus",
        },
        {
          label: "GENERATE INVOICE-EMPLOYEE",
          link: "",
        },
      ])
    );
  }, [location]);

  return (
    <>
      <div className="mt-4 m-4">
        <h2>Selected candidates</h2>
      </div>
      <div className="mt-4 m-4">
        <select
          className="border-[1px] border-border dark:bg-dark rounded-md h-10 p-1 mt-4 text-xs w-48"
          onChange={handleGlobalTenurechange}
        >
          <option>{"SELECT TENURE"}</option>
          {dropDownData.map((data, index) => (
            <React.Fragment key={index}>
              <option value={data}>{data}</option>
            </React.Fragment>
          ))}
        </select>
      </div>
      <div
        className="flex flex-col w-full gap-1 my-2 overflow-x-scroll pt-2 "
        style={rowsData?.data?.length > 4 ? { height: "250px" } : {}}
      >
        <div className="flex">
          {row.map((section, sectionIndex) => (
            <div className="flex flex-col relative" key={sectionIndex}>
              {sectionIndex == 0 && (
                <>
                  <div className={`flex w-full gap-1 `}>
                    <>
                      <h3
                        className={`flex justify-center items-center text-sm ${tableHeading[sectionIndex].bgSecondary} ${tableProperties.colWidth} ${tableProperties.itemHeight}`}
                      >
                        S.NO.
                      </h3>

                      <h3
                        className={`flex justify-center items-center text-sm ${tableHeading[sectionIndex].bgSecondary} ${tableProperties.colWidth} ${tableProperties.itemHeight}`}
                      >
                        EMP ID
                      </h3>

                      <h3
                        className={`flex justify-center items-center text-sm ${tableHeading[sectionIndex].bgSecondary} ${tableProperties.colWidth} ${tableProperties.itemHeight}`}
                      >
                        EMP NAME
                      </h3>
                      <h3
                        className={`flex justify-center items-center text-sm ${tableHeading[sectionIndex].bgSecondary} ${tableProperties.colWidth} ${tableProperties.itemHeight}`}
                      >
                        ACTUAL PROFESSION
                      </h3>

                      <h3
                        className={`flex justify-center items-center text-sm ${tableHeading[sectionIndex].bgSecondary} ${tableProperties.colWidth} ${tableProperties.itemHeight}`}
                      >
                        TENURE
                      </h3>
                      <h3
                        className={`flex justify-center items-center text-sm ${tableHeading[sectionIndex].bgSecondary} ${tableProperties.colWidth} ${tableProperties.itemHeight}`}
                      >
                        VISA FEE
                      </h3>
                      <h3
                        className={`flex justify-center items-center text-sm ${tableHeading[sectionIndex].bgSecondary} ${tableProperties.colWidth} ${tableProperties.itemHeight}`}
                      >
                        IQAMA FEE
                      </h3>
                      <h3
                        className={`flex justify-center items-center text-sm ${tableHeading[sectionIndex].bgSecondary} ${tableProperties.colWidth} ${tableProperties.itemHeight}`}
                      >
                        WORK PERMIT
                      </h3>
                      <h3
                        className={`flex justify-center items-center text-sm ${tableHeading[sectionIndex].bgSecondary} ${tableProperties.colWidth} ${tableProperties.itemHeight}`}
                      >
                        DRIVING LICENSE
                      </h3>
                      <h3
                        className={`flex justify-center items-center text-sm ${tableHeading[sectionIndex].bgSecondary} ${tableProperties.colWidth} ${tableProperties.itemHeight}`}
                      >
                        LABOR CARD
                      </h3>
                      <h3
                        className={`flex justify-center items-center text-sm ${tableHeading[sectionIndex].bgSecondary} ${tableProperties.colWidth} ${tableProperties.itemHeight}`}
                      >
                        INSURANCE
                      </h3>
                      <h3
                        className={`flex justify-center items-center text-sm ${tableHeading[sectionIndex].bgSecondary} ${tableProperties.colWidth} ${tableProperties.itemHeight}`}
                      >
                        BALADIYAH
                      </h3>
                      <h3
                        className={`flex justify-center items-center text-sm ${tableHeading[sectionIndex].bgSecondary} ${tableProperties.colWidth} ${tableProperties.itemHeight}`}
                      >
                        AJEER
                      </h3>
                      <h3
                        className={`flex justify-center items-center text-sm ${tableHeading[sectionIndex].bgSecondary} ${tableProperties.colWidth} ${tableProperties.itemHeight}`}
                      >
                        MEDICAL FOR IQAMA
                      </h3>
                      <h3
                        className={`flex justify-center items-center text-sm ${tableHeading[sectionIndex].bgSecondary} ${tableProperties.colWidth} ${tableProperties.itemHeight}`}
                      >
                        MUQEEM
                      </h3>
                      <h3
                        className={`flex justify-center items-center text-sm ${tableHeading[sectionIndex].bgSecondary} ${tableProperties.colWidth} ${tableProperties.itemHeight}`}
                      >
                        PAYROLL CARD
                      </h3>
                      <h3
                        className={`flex justify-center items-center text-sm ${tableHeading[sectionIndex].bgSecondary} ${tableProperties.colWidth} ${tableProperties.itemHeight}`}
                      >
                        END OF SERVICE
                      </h3>
                      <h3
                        className={`flex justify-center items-center text-sm ${tableHeading[sectionIndex].bgSecondary} ${tableProperties.colWidth} ${tableProperties.itemHeight}`}
                      >
                        VACATION SALARY
                      </h3>
                      <h3
                        className={`flex justify-center items-center text-sm ${tableHeading[sectionIndex].bgSecondary} ${tableProperties.colWidth} ${tableProperties.itemHeight}`}
                      >
                        VACATION TICKET
                      </h3>
                      <h3
                        className={`flex justify-center items-center text-sm ${tableHeading[sectionIndex].bgSecondary} ${tableProperties.colWidth} ${tableProperties.itemHeight}`}
                      >
                        TOTAL AMOUNT
                      </h3>
                    </>
                  </div>
                </>
              )}
              <div className="mb-2">
                {combinedData?.map((data, index) => (
                  <div
                    className="flex w-full gap-1 relative mb-2 mt-2"
                    key={index}
                  >
                    <p
                      className={`bg-slate-200 flex items-center justify-center ${tableProperties.colWidth} ${tableProperties.colHeight}`}
                    >
                      {index + 1}
                    </p>

                    <p
                      className={`bg-slate-200 flex items-center justify-center ${tableProperties.colWidth} ${tableProperties.colHeight}`}
                    >
                      {data.candidate_id}
                    </p>
                    <p
                      className={`bg-slate-200 flex items-center justify-center ${tableProperties.colWidth} ${tableProperties.colHeight}`}
                    >
                      {data.employee_name}
                    </p>
                    <p
                      className={`bg-slate-200 flex items-center justify-center ${tableProperties.colWidth} ${tableProperties.colHeight}`}
                    >
                      {data.actual_profession}
                    </p>
                    <p
                      className={`bg-slate-200 flex items-center justify-center ${tableProperties.colWidth} ${tableProperties.colHeight}`}
                    >
                      {/* {"YTC"} */}
                      <select
                        // className="border-[1px] border-border dark:bg-dark rounded-md h-10 p-1 mt-4 text-xs w-48"
                        className={`bg-slate-200 flex items-center justify-center ${tableProperties.colWidth} ${tableProperties.colHeight}`}
                        onChange={(e) => {
                          handleLocalTenure(e, index);
                        }}
                        value={data.tenure ? data.tenure : globalTenure}
                      >
                        <option>{"SELECT TENURE"}</option>
                        {dropDownData.map((data, index) => (
                          <React.Fragment key={index}>
                            <option value={data}>{data}</option>
                          </React.Fragment>
                        ))}
                      </select>
                    </p>
                    <>
                      {data.fees.map((d, feeIndex) => (
                        <input
                          type="number"
                          key={feeIndex}
                          className={`bg-slate-200 flex items-center justify-center ${tableProperties.colWidth} ${tableProperties.colHeight} text-center`}
                          value={d.cost}
                          onChange={(e) =>
                            handleQuantityChange(
                              index,
                              feeIndex,
                              e.target.value
                            )
                          }
                          name={`fee-${index}`}
                        />
                      ))}
                    </>
                    <p
                      className={`bg-slate-200 flex items-center justify-center ${tableProperties.colWidth} ${tableProperties.colHeight}`}
                    >
                      {data?.totalFees}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
        // className="p-1 bg-red text-white rounded-md max-w-sm m-3 my-2 flex gap-1 ml-30 justify-center items-center"
      >
        <button
          style={{
            padding: "5px 10px",
            fontSize: "16px",
            backgroundColor: "red",
            color: "white",
            border: "none",
          }}
          onClick={() => {
            GenerateInvoice();
          }}
        >
          GENERATE INVOICE
        </button>
      </div>
    </>
  );
}
